/*
 *   File : forgot-password.js
 *   Author : https://evoqins.com
 *   Description : Forgot password page
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

//Custom components
import { CustomPasswordInput, CustomTextInput, OTPInput } from '../../Component/FormElements';
import { PrimaryButton } from '../../Component/Buttons';

import { APIService } from "../../Service";

const ForgotPassword = () => {

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [usernameError, setUserNameError] = useState("");

    const [step, setStep] = useState(0);

    const [otpValue, setOtpValue] = useState("");
    const [focusedInput, setFocusedInput] = useState(2);
    const [confirmOTP, setConfirmOTP] = useState([]);
    const [otpError, setOtpError] = useState("");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [passwordError, setPasswordError] = useState("");

    const [tempToken, setTempToken] = useState("");

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });
    }, []);

    useEffect(() => {
        setUserNameError("");
    }, [username]);

    useEffect(() => {
        setOtpError("");
    }, [otpValue]);

    useEffect(() => {
        setPasswordError("");
    }, [password, confirmPassword]);

    //handle login
    const _handleGetOTP = () => {
        // let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

        if (username.trim().length === 0) {
            setUserNameError("Enter your username");
        } else {
            _getOTP(false);  //API - getOTP 
        }
    }

    // handle OTP 
    const _handleOTP = (e) => {
        if (loading !== true) {
            const input_value = e.target.value;
            if (input_value.length <= 6) {
                setOtpValue(input_value);
                const characters = [];

                for (let i = 0; i < input_value.length; i++) {
                    const character = input_value.charAt(i);
                    characters.push(character);
                }
                setConfirmOTP(characters)
            }
        }
    };

    // handle submit OTP 
    const _handleSubmitOTP = () => {
        if (otpValue.length < 6) {
            setOtpError("Enter received OTP");
        }

        if (otpValue.length === 6) {
            _verifyOTP();
        }
    };

    // handle resend OTP
    const _handleResendOTP = () => {
        setOtpValue("");
        setConfirmOTP([]);
        _sentOTP();
    };

    // handle submit new password
    const _handleConfirmPassword = () => {
        let is_valid = true;
        if (password !== confirmPassword) {
            setPasswordError("Password does not match");
            is_valid = false;
        } else if (password.length <= 0 && confirmPassword.length <= 0) {
            setPasswordError("Password does not match");
            is_valid = false;
        }

        if (is_valid === true) {
            _updatePassword();
        }
    }

    // handle back flow
    const _handleBack = () => {
        if (step === 0) {
            navigate("/login");
        } else if (step === 1) {
            setStep(0);
        } else if (step === 2) {
            setStep(1);
        }
    }

    // API - get OTP 
    const _getOTP = () => {
        setLoading(true);
        let is_post = true;
        let url = 'auth/forgot-password';
        let data = {
            "otp_type": "RESETPASS",
            "username": username,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStep(1);
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };

    // API - Verify OTP 
    const _verifyOTP = () => {
        let is_post = true;
        let url = 'auth/verify-otp';
        let data = {
            "username": username,
            "otp": otpValue,
            "otp_type": "RESETPASS"
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStep(2);
                setTempToken(response.data.temp_token);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    // API - Send OTP 
    const _sentOTP = () => {
        let is_post = true;
        let url = 'auth/send-otp';
        let data = {
            "username": username,
            "otp_type": "RESETPASS"
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                setOtpValue("");
                setConfirmOTP([]);
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                // window.location.href = "/corridor-config";
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    // API - change password 
    const _updatePassword = () => {
        let is_post = true;
        let url = 'auth/set-password';
        let data = {
            "temp_token": tempToken,
            "username":username,
            "confirm_password":confirmPassword,
            "password": password,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                navigate("/");
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        });
    };

    return (
        <>
            {/* <div className={`${step === 0 ? "padding-200px-bottom" : step === 1 ? "padding-176px-bottom" : 'padding-200px-bottom'} e-bg-indigo  padding-32px-top`}> */}
            <div className='e-auth-container e-bg-cover-size'>
                <div className='container'>
                    <div className='text-center'>
                        <img src={require("../../Assets/Images/Login/logo.svg").default}
                            draggable={false}
                            alt='Zappit-icon' />
                    </div>

                    {/* User authentication */}
                    <div className='row padding-40px-top'>
                        <div className='offset-xl-4 offset-lg-3 offset-md-2 offset-sm-1 col-xl-4 col-lg-6 col-md-8 col-sm-10 '>
                            <div className='padding-30px-all e-bg-white-light e-border-radius-16 box-shadow-light-black'>
                                {step !== 2 &&
                                    <img src={require("../../Assets/Images/Login/left-arrow.svg").default}
                                        draggable={false}
                                        className='cursor-pointer'
                                        alt='back-arrow'
                                        onClick={_handleBack} />
                                }
                                {step === 0 ?
                                    <div className='padding-18px-top'>
                                        <h3 className='mb-4 e-primary-font e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                                            User authentication
                                        </h3>
                                        <CustomTextInput label="Enter registered email"
                                            placeholder="Enter email"
                                            type="text"
                                            require
                                            value={username}
                                            error={usernameError}
                                            autoFocus={true}
                                            className="w-100"
                                            labelStyle="e-font-weight-400"
                                            onKeyPress={_handleGetOTP}
                                            handleChange={(e) => setUsername(e)} />

                                        <div className='pt-2'>
                                            <PrimaryButton name="Confirm"
                                                className="e-bg-primary-blue w-100"
                                                status={loading}
                                                onPress={_handleGetOTP} />
                                        </div>
                                    </div>
                                    :
                                    step === 1 ?
                                        <div className='px-2 padding-18px-top'>
                                            <h3 className='mb-2 e-primary-font e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                                                OTP Verification
                                            </h3>
                                            {/* OTP Input */}
                                            <OTPInput label="Enter otp sent to the mail id"
                                                ref={inputRef}
                                                id="otp"
                                                require
                                                value={otpValue}
                                                spellcheck="false"
                                                error={otpError}
                                                focused_input={focusedInput}
                                                confirm_pin={confirmOTP}
                                                onFocus={() => setFocusedInput(2)}
                                                onBlur={() => setFocusedInput(0)}
                                                onKeyPress={_handleSubmitOTP}
                                                onChange={_handleOTP} />
                                            <p className=' mb-0 e-text-light-gray e-primary-font e-font-weight-400 line-height-18px e-font-14'>
                                                Didn’t get code yet?
                                                <span className='ps-1 e-font-14 e-primary-font line-height-18px e-text-primary-blue e-font-weight-500 cursor-pointer text-decoration-hover-underline'
                                                    onClick={_handleResendOTP} >
                                                    Resend OTP
                                                </span>
                                            </p>

                                            <div className='pt-4'>
                                                <PrimaryButton name="Confirm"
                                                    className="e-bg-primary-blue w-100"
                                                    // status={loading}
                                                    onPress={_handleSubmitOTP} />
                                            </div>
                                        </div>
                                        :
                                        // Change password
                                        <div className=''>
                                            <img src={require("../../Assets/Images/Login/left-arrow.svg").default}
                                                draggable={false}
                                                className='cursor-pointer'
                                                alt='back-arrow'
                                                onClick={_handleBack} />
                                            <h3 className='padding-18px-top mb-3 e-primary-font e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                                                Change password
                                            </h3>

                                            <div className='e-note-wrapper mb-2'>
                                                <div className='d-flex align-items-start gap-1'>
                                                    <img draggable={false} src={require("../../Assets/Images/Home/tooltip.svg").default} alt='ToolTip' />
                                                    <div>
                                                        <p className='mb-0 e-text-black e-primary-font e-font-weight-400 line-height-18px e-font-12'>
                                                            Your new password must be at least 8 characters long. It should include a mix of uppercase and lowercase letters, numbers, and special characters.
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* new password */}
                                            <CustomPasswordInput label="Enter new password"
                                                placeholder="Enter password"
                                                type="text"
                                                require
                                                value={password}
                                                autoFocus={true}
                                                className="w-100"
                                                labelStyle="e-font-weight-400"
                                                onKeyPress={_handleConfirmPassword}
                                                handleChange={(e) => setPassword(e)} />

                                            {/* confirm password */}
                                            <CustomPasswordInput label="Confirm password"
                                                placeholder="Enter password"
                                                type="text"
                                                require
                                                value={confirmPassword}
                                                error={passwordError}
                                                className="w-100"
                                                labelStyle="e-font-weight-400"
                                                onKeyPress={_handleConfirmPassword}
                                                handleChange={(e) => setConfirmPassword(e)} />

                                            {/* submit otp button */}
                                            <div className='pt-2'>
                                                {password.length > 0 && confirmPassword.length > 0 ?
                                                    <PrimaryButton name="Confirm"
                                                        className="e-bg-primary-blue w-100"
                                                        onPress={_handleConfirmPassword} />
                                                    :
                                                    <PrimaryButton name="Confirm"
                                                        className="e-bg-primary-blue w-100 e-disable" />
                                                }
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword;